import React from 'react';

import { PaperClipOutlined } from '@ant-design/icons';
import { Badge, Button as AntdButton } from 'antd';
import classNames from 'classnames';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import { Banner } from 'components/Banner';
import ProfileButton from 'components/ProfileButton';
import { useDownloadableFilesContext } from 'hooks/DownloadableFilesContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { profileEnumMapping } from 'utils/enumData';

import FluxStatuses from '../Notification/FluxStatuses';

import './Header.less';

interface HeaderProps {
  className?: string;
}

const Header = ({ className }: HeaderProps): React.ReactElement => {
  const user = useUserStore();
  if (user.profile === null) {
    throw new Error('Authenticated user should be mapped to a profile');
  }

  const { homePath, profilPath, usersAccountPath } =
    profileEnumMapping[user.profile];
  const { newDownloadsNumber, showDownloadablePopUp } =
    useDownloadableFilesContext();

  return (
    <header className={classNames('HeaderContainer', className)}>
      <div className={'TopBarContainer'}>
        <div className={'Left'}>
          <Banner className={'Banner'} pathToRedirect={homePath} />
        </div>
        <div className={'Right'}>
          {user.profile == UserDtoProfileEnum.ADMIN_FONCTIONNEL && (
            <Badge>
              <FluxStatuses />
            </Badge>
          )}
          <Badge count={newDownloadsNumber} className="DownloadableFilesButton">
            <AntdButton
              icon={<PaperClipOutlined />}
              type={'default'}
              shape={'round'}
              onClick={() => showDownloadablePopUp(true)}
            />
          </Badge>
          <ProfileButton
            urlProfil={profilPath}
            urlUsersAccount={usersAccountPath}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
